// Zen Mode prompts — written in the established trauma-informed voice.
// Tone: protective, present, never shaming, anchoring to "what matters".
import { PERSONALIZED_TEMPLATES } from "@/lib/protectData";

export const ZEN_PROMPTS = [
  "What matters most tonight?",
  "What might tomorrow-you want you to consider?",
  "What are you protecting right now?",
  "Who or what is worth staying for?",
  "What's the slowest version of this moment look like?",
  "What does the part of you that loves you want right now?",
  "Reach before the spiral.",
  "One hard night does not define you.",
  "Stillness is also a step forward.",
  "What's underneath the urge?",
  "The kindest thing you could do for yourself in 60 seconds is what?",
  "You do not have to disappear to heal.",
  "If you wait fifteen more minutes, what changes?",
  "What did you want for tonight when things felt a little steadier?",
  "Name one body sensation. Just one.",
  "Something is asking to be felt — not fixed.",
  "Breathe. The next step does not have to be loud.",
  "One safer next step is enough.",
  "Whose name comes up when you ask what's worth protecting?",
  "You're allowed to take the long way home to yourself.",
];

export const BREATH_PHASES = [
  { id: "in", label: "Breathe in", duration: 4 },
  { id: "hold1", label: "Hold", duration: 4 },
  { id: "out", label: "Breathe out", duration: 4 },
  { id: "hold2", label: "Hold", duration: 4 },
];

export const BREATH_CYCLE_MS = BREATH_PHASES.reduce(
  (s, p) => s + p.duration * 1000,
  0
);

export const randomPrompt = (exclude) => {
  const pool = ZEN_PROMPTS.filter((p) => p !== exclude);
  return pool[Math.floor(Math.random() * pool.length)];
};

// Personalize a prompt using the user's Protect List, if present.
// Falls back to a generic ZEN_PROMPT if list is empty.
export const personalizedPrompt = (protectItems, exclude) => {
  if (!protectItems || protectItems.length === 0) return randomPrompt(exclude);
  // Mix: roughly 55% personalized when list exists.
  const usePersonalized = Math.random() < 0.55;
  if (!usePersonalized) return randomPrompt(exclude);
  const item =
    protectItems[Math.floor(Math.random() * protectItems.length)];
  const template =
    PERSONALIZED_TEMPLATES[
      Math.floor(Math.random() * PERSONALIZED_TEMPLATES.length)
    ];
  const text = template(item.label);
  return text === exclude ? randomPrompt(exclude) : text;
};
